<template>
  <label
    :class="checkboxClasses"
  >
    <input
      :checked="model"
      type="checkbox"
      class="common-checkbox__input"
      :disabled="disabled"
      @change="handleChange"
    >
    <span class="common-checkbox__checkmark" />
  </label>
</template>

<script setup lang="ts">
interface Props {
  disabled?: boolean;
}

const model = defineModel<boolean>({ required: true });

const { disabled = false } = defineProps<Props>();

const checkboxClasses = computed(() => [
  'common-checkbox',
  {
    'common-checkbox--disabled': disabled,
    'common-checkbox--checked': model.value,
  },
]);

const handleChange = (event: Event): void => {
  const target = event.target as HTMLInputElement;
  model.value = target.checked;
};
</script>

<style lang="scss" scoped>
.common-checkbox {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  cursor: pointer;
  user-select: none;

  &--disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &__input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
  }

  &__checkmark {
    position: relative;
    width: 1.6rem;
    height: 1.6rem;
    border: 0.16rem solid rgba($color-white-checkbox, 1);
    border-radius: 0.6rem;
    background-color: transparent;
    transition: all 0.3s;
    flex-shrink: 0;

    .common-checkbox--checked & {
      border-color: $color-white;
      background-color: $color-white;
    }

    .common-checkbox--checked &::after {
      content: '';
      position: absolute;
      top: 46%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(45deg);
      width: 0.5rem;
      height: 1rem;
      border: solid $color-red-secondary;
      border-width: 0 0.2rem 0.2rem 0;
    }
  }

  &--disabled &__checkmark {
    cursor: not-allowed;
  }
}
</style>
